<template>
  <footer class="app-footer">
    <a href="http://coreui.io">Club Interactivo</a> &copy; 2017 Ediciones Suramérica.
    <!-- <span class="float-right">Powered by <a href="http://coreui.io">CoreUI</a></span> -->
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// Footer.vue?28d746d5